import { render, staticRenderFns } from "./ChatContainer.vue?vue&type=template&id=431d99a1&scoped=true&"
import script from "./ChatContainer.vue?vue&type=script&lang=js&"
export * from "./ChatContainer.vue?vue&type=script&lang=js&"
import style0 from "./ChatContainer.vue?vue&type=style&index=0&id=431d99a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431d99a1",
  null
  
)

export default component.exports